<template>
  <div class="wg-row vircos-header">
    <img
      class="com-anm22-app-img-fixed-height-l"
      style="margin-right:10px;"
      :src="$anm22.getObjIcon(work, 'workDefault')"
    />
    <div class="wg-row" style="flex-direction:column;">
      <div class="com-anm22-app-text-xl">{{  customer ? project.projectId + ' - ' + customer.firstName.toUpperCase() + ' ' + customer.lastName.toUpperCase() : project.projectId }}</div>
      <div
        v-if="title"
        class="com-anm22-app-text-xl"
      >{{ title }}</div>
    </div>
    <div class="qrcode">
      <qrcode
        :value="'https://tasks.anm22.it/project/' + projectId"
        :options="{ width: 115 }"
        tag="img"
      ></qrcode>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    projectId: [String, Number],
    title: {
      type: String,
      default: ""
    }
  },
  computed: {
    project() {
      return this.$store.getters["projects/get"](this.projectId);
    },
    work() {
      return this.$store.getters["works/get"](16);
    },
    customer() {
      return this.$store.getters["contacts/get"](this.project.customers[0]);
    }
  }
};
</script>

<style lang="scss" scoped>
.vircos-header {
  flex-wrap: nowrap;
  align-items: center;
  padding: 0 5px;
  height: 115px;
}
.qrcode {
  display: block;
  margin-left: auto;
  width: 115px;
  height: 100%;
}
</style>